import { useMutation } from '@tanstack/react-query';

import { accountApi } from '../api';

interface UseCheckoutPaymentParams {
  userId: string;
  email: string;
  priceId: string;
  plan: string;
  offeringId: string;
  successUrl: string;
  cancelUrl: string;
  freeTrialDays?: number;
  referral?: { campaignId: string; rewardfulClientId: string };
  discount?: object;
  userExpectations?: string;
}

export function useCheckoutPayment() {
  const checkoutPayment = useMutation({
    mutationFn: ({
      userId,
      email,
      priceId,
      plan,
      offeringId,
      successUrl,
      cancelUrl,
      freeTrialDays,
      referral,
      discount,
      userExpectations,
    }: UseCheckoutPaymentParams) => {
      return accountApi
        .createStripeCheckoutSession(userId, {
          userId,
          email,
          priceId,
          plan,
          offeringId,
          successUrl,
          cancelUrl,
          freeTrialDays,
          referral,
          discount,
          mode: plan === 'lifetime' ? 'payment' : 'subscription',
          userExpectations,
        })
        .then((res) => {
          return { checkoutUrl: res.data.url, sessionId: res.data.id };
        });
    },
  });

  return {
    checkoutPayment: checkoutPayment.mutateAsync,
    ...checkoutPayment,
  };
}
